import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { cn } from '@repo/utils'

import { ChildrenSchema } from 'utils'

import styles from './index.css'

class CardList extends PureComponent {
  render() {
    const { children, className, disabled, header, highlight, innerRef, tabIndex, ...props } = this.props

    return (
      <section
        {...props}
        className={cn(styles.wrapper, highlight && styles.highlight, disabled && styles.disabled, className)}
        ref={innerRef}
        tabIndex={disabled ? -1 : tabIndex}
      >
        {!!header && <header className={styles.header}>{header}</header>}
        <ol className={styles.list}>{children}</ol>
      </section>
    )
  }
}

CardList.propTypes = {
  children: ChildrenSchema.isRequired,

  className: PropTypes.string,
  disabled: PropTypes.bool,
  header: ChildrenSchema,
  highlight: PropTypes.bool,
  innerRef: PropTypes.func,
  tabIndex: PropTypes.number,
}

CardList.defaultProps = {
  className: '',
  disabled: false,
  header: null,
  highlight: false,
  innerRef: null,
  tabIndex: 0,
}

export default CardList
